export default __webpack_public_path__ + "static/media/star-rating-outline.5f900dd4.svg";